import { RowNode } from '@ag-grid-community/core';
import React, { useEffect, useState } from 'react';
export const EmptyCell = (props) => {
    const { data, node, colDef, children } = props;
    const cellData = (colDef === null || colDef === void 0 ? void 0 : colDef.colId) && data[colDef.colId] ? data[colDef.colId] : {};
    const [isHovering, setIsHovering] = useState(false);
    const showRow = () => setIsHovering(true);
    const hideRow = () => setIsHovering(false);
    useEffect(() => {
        node.addEventListener(RowNode.EVENT_MOUSE_ENTER, showRow);
        node.addEventListener(RowNode.EVENT_MOUSE_LEAVE, hideRow);
        return () => {
            node.removeEventListener(RowNode.EVENT_MOUSE_ENTER, showRow);
            node.removeEventListener(RowNode.EVENT_MOUSE_LEAVE, hideRow);
        };
    }, [node]);
    return React.createElement(React.Fragment, null, children && children(cellData, isHovering, props));
};
//# sourceMappingURL=empty-cell.js.map